import { ActionIcon, Menu } from "@mantine/core";
import { observer } from "mobx-react";
import { BsCheck, BsCheck2Circle, BsThreeDotsVertical } from "react-icons/bs";
import { MdOutlineRestartAlt, MdPlaylistAdd, MdPlaylistRemove } from "react-icons/md";
import { useToggleSaved } from "@/components/playlist/ToggleAddToPlaylistButton";
import { useStores } from "@/hooks/useStores";

interface EpisodeMenuProps {
    episode: Episode;
    podcast: Podcast;
    /** For placing the button, e.g. in the corner of a row */
    className?: string;
    /** Offer saving the episode to the playlist in the menu (where the row has no button of its own for it) */
    withSave?: boolean;
}

const SaveItem = observer(({ episode, podcast }: { episode: Episode; podcast: Podcast }) => {
    const { inList, toggle } = useToggleSaved(episode, podcast);

    return (
        <Menu.Item
            leftSection={inList ? <MdPlaylistRemove size={18} /> : <MdPlaylistAdd size={18} />}
            onClick={toggle}
            rightSection={inList ? <BsCheck size={18} /> : null}>
            {inList ? "Ta bort från spellistan" : "Spara i spellistan"}
        </Menu.Item>
    );
});

/** The "more actions" menu on an episode in a list. For now: mark as played / not played. */
export const EpisodeMenu = observer(({ episode, podcast, className, withSave = false }: EpisodeMenuProps) => {
    const { listeningStore } = useStores();
    const played = listeningStore.isPlayed(episode.id);

    return (
        <Menu position="bottom-end" shadow="md" width={220} withinPortal>
            <Menu.Target>
                <ActionIcon
                    aria-label={`Fler åtgärder för ${episode.title}`}
                    className={className}
                    color="gray"
                    radius="xl"
                    size={36}
                    variant="subtle">
                    <BsThreeDotsVertical size={18} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                {withSave && <SaveItem episode={episode} podcast={podcast} />}
                {played ? (
                    <Menu.Item
                        leftSection={<MdOutlineRestartAlt size={16} />}
                        onClick={() => listeningStore.markUnplayed(episode.id)}>
                        Markera som ospelad
                    </Menu.Item>
                ) : (
                    <Menu.Item
                        leftSection={<BsCheck2Circle size={16} />}
                        onClick={() => listeningStore.markPlayed(episode, podcast)}>
                        Markera som spelad
                    </Menu.Item>
                )}
            </Menu.Dropdown>
        </Menu>
    );
});
